<template>
  <div class='seoBoard'>
    <ig-icon class="weikaishi" name="weikaishi" v-if="status == 1"></ig-icon>
    <ig-icon class="fuwuzhong" name="fuwuzhong" v-if="status == 2"></ig-icon>
    <ig-icon class="tingzhi" name="tingzhi" v-if="status == 3"></ig-icon>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    status() {
      return this.scope.row.status
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.seoBoard div {
  line-height: 24px;
  i {
    font-size: 24px;
  }
  .fuwuzhong {
    color: #7ED776;
  }
  .weikaishi {
    color: #72B5FF
  }
  .tingzhi {
    color: #CDCDCD;
  }
}
</style>
